import React, {Fragment, Component} from "react"
import {Row} from "react-bootstrap"
import {debounce} from "lodash"

import {FormattedMessage} from "@irati/utils/lang"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/Feed"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import FeedQuery, {feedQuery} from "@irati/recognition/apollo/query/Feed"
import {H3} from "@irati/ui/src/Headings"

import CreateRecognitionButton from "../Recognise"
import Card from "./ClosedPoll/Card"
import {EmptyFeed} from "./Empty"
import {FiltersWrapper} from "./Filters/styled"
import Filters from "./Filters"
import LoadMore from "../LoadMore"
import {StyledCol, HeaderWrapper, Feed} from "./styled"

class ClosedPolls extends Component {
  state = {
    variables: feedQuery.variables,
    hasRefetchingError: false
  }

  static propTypes = {}

  onLoadMore = null

  constructor(props, context) {
    super(props, context)
    this.handleScroll = debounce(this.handleScroll, 200)
  }

  componentDidMount() {
    window.addEventListener("online", this.handleNetworkStatusChange)
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleNetworkStatusChange)
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleVisibilityChange = (view) => {
    const variables = {
      ...feedQuery.variables,
      view
    }

    this.setState({
      variables
    })
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state

    if (atBottom && !hasRefetchingError && this.onLoadMore) {
      this.fetchMore()
    }
  }

  handleNetworkStatusChange = () => {
    const {hasRefetchingError} = this.state

    if (navigator.onLine && hasRefetchingError) {
      this.fetchMore()
    }
  }

  fetchMore = () => {
    this.setState({
      hasRefetchingError: false
    })
    this.onLoadMore().catch(() => {
      this.setState({
        hasRefetchingError: true
      })
    })
  }

  hasReceivedData(data) {
    return data &&
      ("recognitionFeed" in data) &&
      ("results" in data.recognitionFeed) &&
      (data.recognitionFeed.results.length > 0)
  }

  renderFilters() {
    const {view} = this.state.variables
    return (
      <FiltersWrapper>
        <Filters onVisibilityChange={this.handleVisibilityChange} view={view} />
      </FiltersWrapper>
    )
  }

  render() {
    const {variables, hasRefetchingError} = this.state
    const feedProps = {...feedQuery, variables}

    return (
      <Fragment>
        <Row>
          <StyledCol xs={12}>
            <HeaderWrapper>
              <H3><FormattedMessage id="recognition.polls.closedPolls.label" /></H3>
              <CreateRecognitionButton />
            </HeaderWrapper>
            <DisablePointerEventsOnScroll>
              <FeedQuery {...feedProps}>
                {({data, fetchMore, refetch, loading: isLoading, error, networkStatus}) => {
                  const hasData = this.hasReceivedData(data)
                  const hasError = error || hasRefetchingError
                  const isFetchingMore = networkStatus === 3

                  const cursor = data && data.recognitionFeed ? data.recognitionFeed.cursor : ""
                  const fetchMoreVariables = {
                    ...variables,
                    cursor
                  }

                  this.onLoadMore = !isLoading ? () => fetchMore(fetchMoreVariables) : null

                  return isLoading && !isFetchingMore ? <Loader /> : (
                    <Fragment>
                      {hasData && (
                        <Fragment>
                          <Feed
                            component={Card}
                            arr={data.recognitionFeed.results}
                            className={null}
                            before={this.renderFilters()} />
                        </Fragment>
                      )}
                      {isLoading && <Loader />}
                      {!isLoading && hasError && <LoadMore onClick={error ? () => refetch() : this.fetchMore} />}
                      {!isLoading && !hasError && !hasData && <EmptyFeed />}
                    </Fragment>
                  )
                }}
              </FeedQuery>
            </DisablePointerEventsOnScroll>
          </StyledCol>
        </Row>
      </Fragment>
    )
  }
}

export default ClosedPolls
